// ABOUTME: Canonical list of UI_APPBAR_* role names that gate AppBar nav items.
// ABOUTME: Keep in sync with keycloak/pim-realm.json and keycloak/create-realm.sh.

export const UI_APPBAR_ROLES = {
    LANGUAGE: 'UI_APPBAR_LANGUAGE',
    PRODUCTS: 'UI_APPBAR_PRODUCTS',
    VIEWER_3D: 'UI_APPBAR_3D_VIEWER',
    HIERARCHIES: 'UI_APPBAR_HIERARCHIES',
    JOBS: 'UI_APPBAR_JOBS',
    TRANSLATIONS: 'UI_APPBAR_TRANSLATIONS',
    SEARCH: 'UI_APPBAR_SEARCH',
    GLOBAL_SEARCH: 'UI_APPBAR_GLOBAL_SEARCH',
    DISCOUNTS: 'UI_APPBAR_DISCOUNTS',
    SHORT_LISTS: 'UI_APPBAR_SHORT_LISTS',
    DATA_QUALITY: 'UI_APPBAR_DATA_QUALITY',
    OFFERS: 'UI_APPBAR_OFFERS',
    ORDERS: 'UI_APPBAR_ORDERS',
    CART: 'UI_APPBAR_CART',
    CRM: 'UI_APPBAR_CRM',
    SETTINGS: 'UI_APPBAR_SETTINGS',
    ADMIN_DASHBOARD: 'UI_APPBAR_ADMIN_DASHBOARD',
    COMPANY_ADMIN: 'UI_APPBAR_COMPANY_ADMIN',
    NOTIFICATIONS: 'UI_APPBAR_NOTIFICATIONS',
    EXTERNAL_CALLS_LOG: 'UI_APPBAR_EXTERNAL_CALLS_LOG',
} as const;

export type UiAppBarRole = (typeof UI_APPBAR_ROLES)[keyof typeof UI_APPBAR_ROLES];
